<template>
  <div>
    <div class="container">
      <div class="row">
        <popUp v-if="articleToggle===true" v-on:doClose="close">
          <div class="pop-title" slot="title">
            <h5>解析</h5>
            <div class="hori-line"></div>
            <br/>
            <h6 style="font-weight: bolder;">{{ translate.title }}</h6>
          </div>
          <div slot="info" class="info-main px-2">
            <!-- pm feed back -->
            <!-- <div class="p-2" style="border:2px solid red;">
              <h5>請提供圖片 (這次統一需求為 jpg)</h5>
                <ul>
                  <li>
                    全寬圖片 為獲得最佳效果，它們的寬度至少應為1400像素，高度無影響。
                  </li>
                  <li>
                    半寬圖片 置放在頭條的半寬圖片至少應為700像素，以獲得最佳品質，高度無影響。
                  </li>
                  <li>
                    1/3寬圖片 為了獲得最佳品質的1/3寬度圖像，推薦至少使用480像素寬度的圖片，高度無影響。
                  </li>
                  <li>
                    1/4寬圖片 要獲得最佳品質的1/4寬度圖像，它們的寬度應至少為360像素，高度無影響。
                  </li>
                </ul>
            </div> -->
            <img class="question-image p-2" style="width: 70%;" v-if="translate.image" :src="require(`@/assets/toeic/part${part}/image/${translate.image}.jpg`)" alt=""  srcset="">
            <div v-if="translate.conversation" >
              <div v-for="(item, index) in translate.conversation">
                <div class="mt-2">
                  <p>
                    <span v-if="item.speaker!==''">
                      {{ item.speaker }}:
                    </span>
                    {{ item.text }}
                  </p>
                  <p>
                    {{ item.translation }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </popUp>
        <popUp :size="popSize" v-if="toggle===true" v-on:doClose="close">
          <div class="pop-title px-2" slot="title">
            <h5>解析</h5>
            <div class="hori-line"></div>
            <br/>
            <h6 style="font-weight: bolder;">{{ answerDetail.title.text }}</h6>
            <h6 style="font-weight: bolder;">{{ answerDetail.title.translate }}</h6>
          </div>
          <div slot="info" class="info-main px-2">
            <p>{{answerDetail.resolve}}</p>
            <div v-if="part!=='6'" v-for="(item, index) in answerDetail.detail" :key="index" class="p-3">
              <div class="d-flex align-items-center">
                <span class="detail-title" :class="{'answer': item.key === answer}">
                  答案: {{ item.key }}
                </span>
                <span class="mx-2">
                  <img style="width: 25px;" v-if="item.key === answer" src="../../assets/image/toeic/icon_TOEIC_answer_correct.png" alt=""  srcset="">
                  <img style="width: 25px;" v-else src="../../assets/image/toeic/icon_TOEIC_answer_wrong.png" alt=""  srcset="">
                </span>
              </div>
              <div class="detail-box p-3" :class="{'answer-border': item.key === answer}">
                <span>
                  {{ item.text }}
                </span>
                <br/>
                <span>
                  {{ item.translate }}
                </span>
              </div>
            </div>
          </div>
        </popUp>
        <div class="col-12 mb-3 d-flex align-items-center rwd-hide">
          <div class="mx-auto" style="text-align: center;">
            <img v-if="mode==='guide'" style="width:125px;" class="pointer mx-3" src="../../assets/image/toeic/btn_TOEIC_strategy_on.png" alt="" srcset="">
            <img @click="mode='guide'" style="width:125px;" v-else class="pointer mx-3" src="../../assets/image/toeic/btn_TOEIC_strategy_off.png" alt="" srcset="">
            <img @click="mode='practice'" style="width:125px;" v-if="mode==='guide'" class="pointer mx-3" src="../../assets/image/toeic/btn_TOEIC_practise_off.png" alt="" srcset="">
            <img v-else style="width:125px;" class="pointer mx-3" src="../../assets/image/toeic/btn_TOEIC_practise_on.png" alt="" srcset="">
          </div>
        </div>
        <div class="row" v-if="mode==='guide'">
          <div class="col-12">
            <div class="d-flex my-3">
              <h3 class="title pr-3">考前須知</h3>
              <div class="line"></div>
            </div>
            <div class="row my-3">
              <div>
                <ul>
                  <li v-for="(item, index) in inputExam.description" :key="index">{{ item }}</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="d-flex my-3">
              <h3 class="title pr-3">解題技巧</h3>
              <div class="line"></div>
            </div>
            <div class="row my-3">
              <div>
                <ul>
                  <li v-for="(item, index) in inputExam.solving_ability" :key="index">{{ item }}</li>
                </ul>
              </div>
            </div>
            <ul style="max-width: 300px;" v-if="part==='7'" class="list-group">
              <li class="list-group-item">advertisement 廣告</li>
              <li class="list-group-item">letter/e-mail 信件／電子郵件</li>
              <li class="list-group-item">memo/notice 備忘錄／公告</li>
              <li class="list-group-item">calendar/schedule 日程／時間表</li>
              <li class="list-group-item">form/graph 表格／圖表</li>
              <li class="list-group-item">text message chain 即時訊息對話</li>
              <li class="list-group-item">article 文章</li>
            </ul>
          </div>
          <div class="col-12"  v-if="part==='4'">
            <div class="d-flex my-3">
              <h3 class="title pr-3">常見獨白類型</h3>
              <div class="line"></div>
            </div>
            <ul style="max-width: 80%;" class="list-group">
              <li class="list-group-item">
                <h6>
                  Announcement 公告或宣布
                </h6>
                機場或機艙廣播／商場或公共場所廣播／辦公室公告
                </li>
              <li class="list-group-item">
                <h6>
                  Introduction 介紹或引言
                </h6>
                介紹來賓／公司或產品簡介／會議或活動開場白／導覽介紹
                </li>
              <li class="list-group-item">
                <h6>
                  Instruction 指示或說明
                </h6>
                員工訓練／工作或活動流程說明
                </li>
              <li class="list-group-item">
                <h6>
                  Media Broadcast 廣播或電視媒體
                </h6>
                電視或電台節目／新聞報導／廣告行銷／路況或天氣報導
                </li>
              <li class="list-group-item">
                <h6>
                  Voice Message 語音訊息
                </h6>
                電話留言／電話語音系統
                </li>
              <li class="list-group-item">
                <h6>
                  Speech/Lecture 演講
                </h6>
                各類主題演講／會議簡報／得獎或退休感言
                </li>
            </ul>
          </div>
          <div class="col-12">
            <div class="d-flex my-3">
              <h3 class="title pr-3">題型分類</h3>
              <div class="line"></div>
            </div>
            <div class="row my-3" >
              <div v-for="(item, index) in inputExam.question_type" :key="index" class="col-md-6 my-3">
                <div class="row align-items-stretch" style="min-height:180px">
                  <div class="col-3 d-flex align-items-center" :class="{'color-box1': item.color===0 ,'color-box2': item.color===1}"  style="color:#fff;text-align:center;">
                    <div class="mx-auto">
                      {{ item.type_name }}
                    </div>
                  </div>
                  <div class="col-9 m-auto">
                    <div class="guide-box">
                      <ul :class="{'tips':item.type_info.length===1}">
                        <li v-for="(el, index) in item.type_info" :key="index" >{{ el }}</li>
                        <!-- pm feed back -->
                        <!-- <div class="p-2" style="border:2px solid red;">
                          此區塊根據上份需求，已修正為齊頭齊尾，如果英文數量不足，將會自動換行補足段落。
                        </div> -->
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container my-3" v-else>
          <h5>Directions  : </h5>
          {{ inputExam.description_en }}
          <!-- part1 -->
          <div v-if="localExam.part === 1" class="row my-5" v-for="(item, index) in localExam.questions" :key="index">
            <div class="col-md-5 d-flex">
              <div class="d-flex align-items-center color-box2" style="color:#fff;text-align:center;">
                <div class="mx-auto">
                  <p>{{ item.num }}</p>
                  <p>{{ item.sub_type }}</p>
                </div>
              </div>
              <div class="object-fit-container ml-2">
                <img class="ml-2 question-image" style="width:100%" :src="require(`@/assets/toeic/part1/image/${item.imageName}.jpg`)" alt="" srcset="">
              </div>
            </div>
            <div class="col-md-7 py-2">
              <div class="d-flex align-items-center">
                <button type="button" @click="changeVoice(item, 'en')" class="btn btn-outline-danger" :class="{'active': item.currentVoice ==  'en'}">
                  <font-awesome-icon icon="volume-up" class="text-sm mr-2" />美英
                </button>
                <button type="button" @click="changeVoice(item, 'au')" class="btn btn-outline-danger mx-2" :class="{'active': item.currentVoice ==  'au'}">
                  <font-awesome-icon icon="volume-up" class="text-sm mr-2" />澳加
                </button>
                <audio :ref="`audioPlayer_${item.num}`" controls controlsList="nodownload" :id="item.currentVoice">
                  <source :src="item.audioSource"  type="audio/mp3" />
                </audio>
              </div>
              <div class="d-flex justify-content-between align-items-stretch">
                <div class="d-flex flex-fill flex-column align-items-start align-items-center">
                  <div v-for="(el, index) in item.items" class="my-2  pointer select-box" :key="index">
                    <div :class="{'correct-box':item.answer===item.userAnswer && item.userAnswer === el.key, 'wrong-box':item.answer!==item.userAnswer && item.userAnswer === el.key}" @click="selectAnswer(item, el.key)" class="my-auto py-2">{{ el.key }}</div>
                  </div>
                </div>
                <div>
                  <button style="height:100%" type="button" @click="openAnswerDetail(item.answerDetail, item.answer)" class="btn btn-secondary ml-2">查看答案解析</button>
                </div>
              </div>
            </div>
          </div>
          <!-- part2 -->
          <div v-if="localExam.part === 2" class="row my-5" v-for="(item, index) in localExam.questions" :key="index">
            <div class="col-md-2 d-flex">
              <div class="d-flex align-items-center color-box2" style="color:#fff;text-align:center; width:100%;">
                <div class="mx-auto py-2">
                  <p>{{ item.num }}</p>
                  <p>{{ item.sub_type }}</p>
                    <!-- pm feed back -->
                  <!-- <div class="p-2" style="border:2px solid red;">
                    此區塊為共用區塊，無法個別進行調整。
                  </div> -->
                </div>
              </div>
            </div>
            <div class="col-md-10">
              <div class="d-flex align-items-center py-2">
                <button type="button" @click="changeVoice(item, 'en')" class="btn btn-outline-danger" :class="{'active': item.currentVoice ==  'en'}">
                  <font-awesome-icon icon="volume-up" class="text-sm mr-2" />美英
                </button>
                <button type="button" @click="changeVoice(item, 'au')" class="btn btn-outline-danger mx-2" :class="{'active': item.currentVoice ==  'au'}">
                  <font-awesome-icon icon="volume-up" class="text-sm mr-2" />澳加
                </button>
                <audio :ref="`audioPlayer_${item.num}`" controls controlsList="nodownload" :id="item.currentVoice">
                  <source :src="item.audioSource"  type="audio/mp3" />
                </audio>
              </div>
              <div class="d-flex justify-content-between align-items-stretch">
                <div class="d-flex flex-fill flex-column align-items-start align-items-center">
                  <div v-for="(el, index) in item.items" class="my-2  pointer select-box" :key="index">
                    <div :class="{'correct-box':item.answer===item.userAnswer && item.userAnswer === el.key, 'wrong-box':item.answer!==item.userAnswer && item.userAnswer === el.key}" @click="selectAnswer(item, el.key)" class="my-auto py-2">{{ el.key }}</div>
                  </div>
                </div>
                <div>
                  <button style="height:100%" type="button" @click="openAnswerDetail(item.answerDetail, item.answer)" class="btn btn-secondary ml-2">查看答案解析</button>
                </div>
              </div>
            </div>
          </div>
          <!-- part3 -->
          <div v-if="localExam.part === 3"  class="row my-5" v-for="(item, index) in localExam.questions" :key="index">
            <div class="col-12">
              <h6>{{ item.title }}</h6>
              <div class="d-flex align-items-center">
                <button type="button" @click="changeVoice(item, 'en')" class="btn btn-outline-danger" :class="{'active': item.currentVoice ==  'en'}">
                  <font-awesome-icon icon="volume-up" class="text-sm mr-2" />美英
                </button>
                <button type="button" @click="changeVoice(item, 'au')" class="btn btn-outline-danger mx-2" :class="{'active': item.currentVoice ==  'au'}">
                  <font-awesome-icon icon="volume-up" class="text-sm mr-2" />澳加
                </button>
                <audio :ref="`audioPlayer_${item.num}`" controls controlsList="nodownload" :id="item.currentVoice">
                  <source :src="item.audioSource"  type="audio/mp3" />
                </audio>
              </div>
              <div>
                <div class="object-fit-container col-12 my-2">
                  <!-- {{ item.imageName }} -->
                  <img style="max-width: 50%; margin:0% 20%" class="m-auto question-image" v-if="item.imageName!==''" :src="require(`@/assets/toeic/part3/image/${item.imageName}.jpg`)" alt=""  srcset="">
                  <div class="mt-2" style="text-align: right;">
                    <button style="height:100%" type="button" @click="openTranslate(item.translate)" class="btn btn-secondary">查看對話內容</button>
                  </div>
                </div>
                <div class="row my-4" v-for="(el, index) in  item.childs" :key="index">
                  <div class="col-md-5 d-flex" >
                    <div class="d-flex align-items-center color-box2" style="color:#fff; width:20%;text-align:center;">
                      <div class="mx-auto py-2">
                        <p>{{ el.num }}</p>
                        <p>{{ el.sub_type }}</p>
                      </div>
                    </div>
                    <div class="question-box ml-2 d-flex align-items-center ">
                      {{ el.title }}
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="d-flex justify-content-between align-items-stretch py-2">
                      <div class="d-flex flex-fill flex-column align-items-start align-items-center">
                        <div v-for="(e, index) in el.items" class="my-2  pointer select-box" :key="index">
                          <div style="text-align:left" :class="{'correct-box':el.answer===el.userAnswer && el.userAnswer === e.key, 'wrong-box':el.answer!==el.userAnswer && el.userAnswer === e.key}" @click="selectAnswer(el, e.key)" class="my-auto py-2 px-2">({{ e.key }}) {{ e.text }}</div>
                        </div>
                      </div>
                      <div>
                        <button style="height:100%" type="button" @click="openAnswerDetail(el.answerDetail, el.answer)" class="btn btn-secondary ml-2">查看答案解析</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- part4 -->
          <div v-if="localExam.part === 4"  class="row my-5" v-for="(item, index) in localExam.questions" :key="index">
            <div class="col-12">
              <!-- <h6>{{ item.title }}</h6> -->
              <div class="d-flex align-items-center">
                <button type="button" @click="changeVoice(item, 'en')" class="btn btn-outline-danger" :class="{'active': item.currentVoice ==  'en'}">
                  <font-awesome-icon icon="volume-up" class="text-sm mr-2" />美英
                </button>
                <button type="button" @click="changeVoice(item, 'au')" class="btn btn-outline-danger mx-2" :class="{'active': item.currentVoice ==  'au'}">
                  <font-awesome-icon icon="volume-up" class="text-sm mr-2" />澳加
                </button>
                <audio :ref="`audioPlayer_${item.num}`" controls controlsList="nodownload" :id="item.currentVoice">
                  <source :src="item.audioSource"  type="audio/mp3" />
                </audio>
              </div>
              <div>
                <div class="object-fit-container col-12 my-2">
                  <img style="width: 60%; margin:0% 20%"  class="m-auto question-image" v-if="item.imageName!==''" :src="require(`@/assets/toeic/part4/image/${item.imageName}.jpg`)" alt=""  srcset="">
                  <div class="mt-2" style="text-align: right;">
                    <button style="height:100%" type="button" @click="openTranslate(item.translate)"  class="btn btn-secondary">查看獨白內容</button>
                  </div>
                </div>
                <div class="row my-4" v-for="(el, index) in  item.childs" :key="index">
                  <div class="col-md-5 d-flex" >
                    <div class="d-flex align-items-center color-box2" style="color:#fff; width:20%;text-align:center;">
                      <div class="mx-auto py-2">
                        <p>{{ el.num }}</p>
                        <p>{{ el.sub_type }}</p>
                      </div>
                    </div>
                    <div class="question-box ml-2 d-flex align-items-center ">
                      {{ el.title }}
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="d-flex justify-content-between align-items-stretch py-2">
                      <div class="d-flex flex-fill flex-column align-items-start align-items-center">
                        <div v-for="(e, index) in el.items" class="my-2  pointer select-box" :key="index">
                          <div style="text-align:left" :class="{'correct-box':el.answer===el.userAnswer && el.userAnswer === e.key, 'wrong-box':el.answer!==el.userAnswer && el.userAnswer === e.key}" @click="selectAnswer(el, e.key)" class="my-auto py-2 px-2">({{ e.key }}) {{ e.text }}</div>
                        </div>
                      </div>
                      <div>
                        <button style="height:100%" type="button" @click="openAnswerDetail(el.answerDetail, el.answer)" class="btn btn-secondary ml-2">查看答案解析</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- part5 -->
          <div v-if="inputExam.part === 5" class="row my-5" v-for="(item, index) in inputExam.questions" :key="index">
            <div class="col-md-5 d-flex">
              <div class="d-flex align-items-center color-box2" style="color:#fff;text-align:center;">
                <div class="mx-auto py-2">
                  <p>{{ item.num }}</p>
                  <p>{{ item.sub_type }}</p>
                </div>
              </div>
              <div class="question-box ml-2 d-flex align-items-center ">
                {{ item.title }}
              </div>
            </div>
            <div class="col-md-7">
              <div class="d-flex justify-content-between align-items-stretch py-2">
                <div class="d-flex flex-fill flex-column align-items-start align-items-center">
                  <div v-for="(el, index) in item.items" class="my-2  pointer select-box" :key="index">
                    <div style="text-align:left" :class="{'correct-box':item.answer===item.userAnswer && item.userAnswer === el.key, 'wrong-box':item.answer!==item.userAnswer && item.userAnswer === el.key}" @click="selectAnswer(item, el.key)" class="my-auto px-2 py-2">({{ el.key }}) {{ el.text }}</div>
                  </div>
                </div>
                <div>
                  <button style="height:100%" type="button" @click="openAnswerDetail(item.answerDetail, item.answer)" class="btn btn-secondary ml-2">查看答案解析</button>
                </div>
              </div>
            </div>
          </div>
          <!-- part6 -->
          <div v-if="inputExam.part === 6"  class="row my-5" v-for="(item, index) in inputExam.questions" :key="index">
            <div class="col-12">
              <h6>{{ item.title }}</h6>
              <div>
                <div class="object-fit-container col-12 my-2">
                  <img style="width: 60%; margin:0% 20%" class="m-auto question-image" v-if="item.imageName!==''" :src="require(`@/assets/toeic/part6/image/${item.imageName}.jpg`)" alt=""  srcset="">
                  <div class="mt-2" style="text-align: right;">
                    <button style="height:100%" type="button" @click="openTranslate(item.translate)" class="btn btn-secondary">查看中文翻譯</button>
                  </div>
                </div>
                <div class="row my-4" v-for="(el, index) in  item.childs" :key="index">
                  <div class="col-md-1 d-flex" >
                    <div class="d-flex align-items-center color-box2 px-2" style="color:#fff; width:100%;text-align:center;">
                      <div class="mx-auto py-2">
                        <p>{{ el.num }}</p>
                        <p>{{ el.sub_type }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-11">
                    <div class="mx-2 my-2 d-flex justify-content-between align-items-stretch">
                      <div class="d-flex flex-fill flex-column align-items-start align-items-center">
                        <div v-for="(e, index) in el.items" class="my-2  pointer select-box" :key="index">
                          <div style="text-align:left" :class="{'correct-box':el.answer===el.userAnswer && el.userAnswer === e.key, 'wrong-box':el.answer!==el.userAnswer && el.userAnswer === e.key}" @click="selectAnswer(el, e.key)" class="my-auto py-2 px-2">({{ e.key }}) {{ e.text }}</div>
                        </div>
                      </div>
                      <div>
                        <button style="height:100%" type="button" @click="openAnswerDetail(el.answerDetail, el.answer)" class="btn btn-secondary ml-2">查看答案解析</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- part7 -->
          <div v-if="inputExam.part === 7"  class="row my-5" v-for="(item, index) in inputExam.questions" :key="index">
            <div class="col-12">
              <h6>{{ item.title }}</h6>
              <div>
                <div class="object-fit-container col-12 my-2">
                  <img style="width: 60%; margin:0% 20%"  class="m-auto question-image" v-if="item.imageName!==''" :src="require(`@/assets/toeic/part7/image/${item.imageName}.jpg`)" alt=""  srcset="">
                  <div class="mt-2" style="text-align: right;">
                    <button style="height:100%" type="button" @click="openTranslate(item.translate)" class="btn btn-secondary">查看中文翻譯</button>
                  </div>
                </div>
                <div class="row my-4" v-for="(el, index) in  item.childs" :key="index">
                  <div class="col-md-5 d-flex" >
                    <div class="d-flex align-items-center color-box2 py-2" style="color:#fff; width:20%;text-align:center;">
                      <div class="mx-auto py-2">
                        <p>{{ el.num }}</p>
                        <p>{{ el.sub_type }}</p>
                      </div>
                    </div>
                    <div class="question-box ml-2 d-flex align-items-center">
                      {{ el.title }}
                    </div>
                  </div>
                  <div class="col-md-7">
                    <div class="d-flex justify-content-between align-items-stretch py-2">
                      <div class="d-flex flex-fill flex-column align-items-start align-items-center">
                        <div v-for="(e, index) in el.items" class="my-2  pointer select-box" :key="index">
                          <div style="text-align:left" :class="{'correct-box':el.answer===el.userAnswer && el.userAnswer === e.key, 'wrong-box':el.answer!==el.userAnswer && el.userAnswer === e.key}" @click="selectAnswer(el, e.key)" class="my-auto py-2 px-2">({{ e.key }}) {{ e.text }}</div>
                        </div>
                      </div>
                      <div>
                        <button style="height:100%" type="button" @click="openAnswerDetail(el.answerDetail, el.answer)" class="btn btn-secondary ml-2">查看答案解析</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-if="currentVoice!==''">
          <audio :id="currentVoice">
            <source :src="require(`@/assets/toeic/part${part}/voice/${currentVoice}.mp3`)" type="audio/mp3">
          </audio>
        </div> -->
        <button v-if="mode==='guide'" @click="goPage('practice') " type="button" class="btn btn-danger mx-auto">開始題型練習</button>
        <button v-else @click="goPage('guide')" type="button" class="btn btn-danger mx-auto">回到題型攻略</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../store/api'
import popUp from '../../components/PopUp.vue'
export default {
  name: 'Toeic-exam',
  components: {
    popUp
  },
  data () {
    return {
      mode: 'guide',
      toggle: false,
      articleToggle: false,
      localExam: JSON.parse(JSON.stringify(this.inputExam)),
      answerDetail: null,
      translate: null,
      answer: "A",
      popSize: 'middle'
    }
  },
  props:{
    inputExam: {
      require: true
    }
  },
  computed: {
    part () {
      return this.$route.params.id
    }
  },
  watch: {
  },
  mounted () {
    this.localExam.questions.forEach(question => {
      this.$set(question, 'currentVoice', 'en')
      question.audioSource = require(`@/assets/toeic/part${this.part}/voice/${question.audioName_en}.mp3`)
      console.log(this.localExam)
    })
    if (this.part === '6') {
      this.popSize = 'small'
    }
  },
  methods: {
    selectAnswer (item, key) {
      this.$set(item, 'userAnswer', key)
    },
    changeVoice(question, type) {
    this.$set(question, 'currentVoice', type)
    try {
      question.audioSource = require(`@/assets/toeic/part${this.localExam.part}/voice/${type === 'en' ? question.audioName_en : question.audioName_au}.mp3`)
    } catch (error) {
      console.error("Failed to load audio source:", error.message)
      return
    }
    this.$nextTick(() => {
      const audioRef = this.$refs[`audioPlayer_${question.num}`]
      const audio = Array.isArray(audioRef) ? audioRef[0] : audioRef
      if (audio) {
        this.pauseAll()
        audio.src = question.audioSource
        audio.load()
        audio.play().catch(error => {
          console.log("Audio play was interrupted: ", error.message)
        })
      } else {
        console.error("Audio element not found for:", question.num)
      }
    });
  },
    pauseAll () {
      let audios = document.getElementsByTagName('audio')
      const self = this
      const allAudios = []
      allAudios.forEach.call(audios, function (i) {
        i.currentTime = 0
        i !== self && i.pause()
      })
    },
    openAnswerDetail (item, answer) {
      this.toggle = true
      this.answerDetail = item
      this.answer = answer
    },
    openTranslate (item) {
      this.articleToggle = true
      this.translate = item
    },
    playAudio(el) {
      if (!el) {
        console.error("No valid audio element provided.")
        return
      }
      let audio = document.getElementById(el)
      if (audio) {
        this.pauseAll()
        audio.load()
        audio.play()
      } else {
        console.error(`Audio element with id "${el}" not found.`)
      }
    },
    pauseAll () {
      let audios = document.getElementsByTagName('audio')
      const self = this
      const allAudios = []
      allAudios.forEach.call(audios, function (i) {
        i.currentTime = 0
        i !== self && i.pause()
      })
    },
    close (close) {
      this.articleToggle = close
      this.toggle = close
    },
    goPage (page) {
      this.mode = page
      this.scrollTop()
    },
    scrollTop () {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/styles/custom.scss";
  .banner {
    height: 60vh;
    background-image: url('../../assets/image/pic/banner_bg_toeic_top.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .title-box {
      width: 50%;
      .text-box {
        width: 50%;
        margin: auto;
        h4 {
          line-height: 200px;
          text-align: center;
          font-size: 150px;
          font-weight: 900;
          color: #fff;
          -webkit-text-stroke: 1.5px rgb(0, 0, 0);
        }
      }
    }
  }
  @media(max-width: 1080px){
    .banner {
      background-position: 0 0;
      .banner-box {
        display: none !important;
      }
    }
  }
  .container {
    text-align: left;
  }
  .object-fit-container {
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
  .main-title {
    font-weight: 800;
    color: $main-color;
  }
  .color-box1 {
    padding: 0 5px;
    min-width: 90px;
    background-color: #db9c4f;
  }
  .tips {
    list-style: none;
  }
  .color-box2 {
    padding: 0 5px;
    min-width: 90px;
    background-color: #ca6b3b;
  }
  .select-box {
    border: 1px solid rgb(73, 73, 73);
    border-radius: 2px;
    text-align:center;
    width: 100% !important;
  }
  .hori-line {
    width: 100%;
    height: 1px;
    margin-bottom: 10px;
    border-top: solid #2c3e50 1.5px;
  }
  .guide-box {
    //margin: auto;
    display: table;
    ul {
      margin-right: 15px;
      text-align: justify;
    }
  }
  .list-group-item {
    border-color: #2c3e50;
    h6 {
      font-weight: bold;
    }
  }
  .question-box {
    text-align: left;
    width: 100%;
    padding: 0 20px;
    border: 1px solid rgb(73, 73, 73);
  }
  .select-box:hover {
    background-color: rgb(212, 212, 212);
  }
  .correct-box {
    color: #328C12;
    background-color: #CEFFC6;
    border-color: #328C12 !important;
  }
  .wrong-box {
    color: #F30000;
    background-color: #FFC2C2;
    border-color: #F30000 !important;
  }

  .detail-title {
    width: 100px;
    text-align: center;
    padding: 5px;
    font-weight: 800;
    color: #F30000;
    background-color: #FFC2C2;
    border-radius: 5px 5px 0px 0px;
    border-width: 1px 1px 0 1px;
    border-style: solid;
    border-color: #F30000;
  }
  .answer {
    color: #328C12;
    border-color: #328C12;
    background-color: #CEFFC6;
  }
  .answer-border {
    border: 1px solid #328C12 !important;
  }
  .detail-box {
    border: 1px solid #F30000;
  }
  .title {
    font-size: 1.5rem;
    font-weight: 800;
    color: $main-color;
    background-color: $white-color;
    z-index: 10;
  }
  .line {
    width: 100%;
    position: absolute;
    // left: 100%;
    top: 32px;
    border-top: black 1px solid;
  }
  .rwd-show {
    display: none;
  }
  @media screen and (max-width: 420px) {
    .rwd-hide {
      display: none !important;
    }
    .rwd-show {
      display: block;
    }
    .banner {
      height: 30vh;
      background-size: contain;
      background-image: url('../../assets/image/pic/banner_bg_toeic_top_SM_W.jpg');
    }
    .question-image {
      width: 100% !important;
    }
  }
</style>
